'use strict'

module.exports = require('./html')



//////////////////
// WEBPACK FOOTER
// ./~/hastscript/index.js
// module id = 195
// module chunks = 35783957827783 204390864267482 254791781388126